/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicationCompanyPartial } from './publicationCompanyPartial';
import { PublicationBusinessUnitPartial } from './publicationBusinessUnitPartial';
import { PublicationDetailPartial } from './publicationDetailPartial';
import { PublicationPartial } from './publicationPartial';
import { PublicationCityPartial } from './publicationCityPartial';
import { PublicationUserPartial } from './publicationUserPartial';


export interface PublicationControllerUpdateByIdRequest { 
    publication?: PublicationPartial;
    publicationDetail?: Array<PublicationDetailPartial>;
    publicationUser?: Array<PublicationUserPartial>;
    publicationCompany?: Array<PublicationCompanyPartial>;
    publicationBusinessUnit?: Array<PublicationBusinessUnitPartial>;
    publicationCity?: Array<PublicationCityPartial>;
}

